/**
 * Routes where the player is inside an active battle (MvM/hex, PvP, tournament, PvE, alliance-leadership).
 * Used to suppress interruptive global modals/toasts during a fight — they should surface only once the
 * battle screen is left (i.e. the battle is finished).
 */
export const BATTLE_PATH_PREFIXES = [
  '/hex-battle', // MvM castle / tower / barbarian-village hex battle
  '/pvp/battle', // PvP battle room (+ /observe)
  '/pvp/alliance-leadership', // alliance leadership PvP room
  '/tournament/battle', // tournament battle
  '/pve/battlefield', // PvE battlefield
] as const

/** True when `pathname` is (or is under) any battle route. */
export function isOnBattlePath(pathname: string): boolean {
  return BATTLE_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}
